<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="documentType.title"
          :link="[
            {
              text: 'Hồ sơ Ban Giám Hiệu',
              href: '../managerDocumentTypes',
            },
          ]"
        />
      </div>
      <div class="flex-center" v-if="role.type !== 'inspector'">
        <v-btn color="primary" class="elevation-0" @click="upload">
          <span>Upload tệp</span>
          <input ref="uploader" type="file" class="d-none" accept=".pdf, .xlsx, .doc, .docx" @change="onFileChanged" />
        </v-btn>
      </div>
    </div>

    <v-card outlined class="mx-4 elevation-0">
      <div class="d-flex align-center justify-space-between px-6 py-4" v-if="selecteds && selecteds.length">
        <div class="d-flex flex-column">
          <span>
            {{ 'Đã chọn ' + selecteds.length + ' file' }}
          </span>
        </div>

        <v-btn small color="primary" @click="removeFiles">Xóa file</v-btn>
      </div>
      <ManagerDocumentDataTable :selected.sync="selecteds" ref="table" />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ManagerDocumentDataTable from '@/modules/managerDocument/ManagerDocumentDataTable.vue'
import { get } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Breadcrumbs,
    ManagerDocumentDataTable,
  },
  data() {
    return {
      isSelecting: false,
      typeId: '',
      documentType: {},
      selecteds: [],
    }
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds', 'profile', 'role', 'user']),
  },
  async created() {
    this.typeId = this.$route.params.id
    this.documentType = await this.fetchDocumentType(this.typeId)
  },
  methods: {
    ...mapActions('Documents', ['createDocument', 'removeDocument', 'removeDocuments', 'fetchDocumentType']),
    ...mapActions('upload', ['uploadFile']),

    upload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      const file = e.target.files[0]

      let createdDocument = {}
      try {
        // create document
        const data = {
          documentType: this.typeId,
          createdUser: this.user.id,
        }
        const schoolYear = get(this.$route.params, 'year', null)
        if (schoolYear) {
          data.schoolYear = schoolYear
        }
        createdDocument = await this.createDocument(data)
        // upload file
        let formData = new FormData()
        formData.append('files', file)
        formData.append('refId', createdDocument.id)
        formData.append('ref', 'document')
        formData.append('field', 'file')
        await this.uploadFile(formData)

        this.$alert.success('Tải file thành công')
        await this.$refs.table.refresh({ documentType: this.typeId })
      } catch (error) {
        this.$alert.error('Tải file thất bại, vui lòng thử lại. Lỗi: ' + error)
        if (createdDocument.id) await this.removeDocument(createdDocument.id)
      } finally {
        this.$loading.active = false
      }
    },
    async search() {
      await this.$refs.table.refresh({ documentType: this.typeId })
    },
    async removeFiles() {
      this.$dialog.confirm({
        title: 'Xóa tài liệu',
        text: `Bạn có Chắc Chắn muốn xóa ${this.selecteds && this.selecteds.length} tài liệu này không ?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.removeDocuments(this.selecteds.map(f => f.id))
            await this.search()
            this.$alert.deleteSuccess()
            this.selecteds = []
          } catch (error) {
            this.$alert.deleteError(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
}
</script>
<style scoped></style>
